import { Registration } from "../types/Types";
import { api } from "./Api";

const BASE_PATH = '/api/register';

export const registerPartner = async (data: Registration) => {
    return await api.post<any, any>(`${BASE_PATH}`, JSON.stringify(data));
}